module.exports = __webpack_public_path__ + "img/security-original.f8eb3061.gif";